export function enrollmentStatus (value) {
  if (!value) return ''
  const status = ['處理中', '正取', '備取', '已取消']
  return status[value]
}

export function openingStatus (value) {
  const bool = `${value}`
  if (!bool) return ''
  const status = {
    'true': '開放中',
    'false': '已關閉'
  }
  return status[bool]
}

export function toN (value) {
  const arr = Array.apply(null, { length: value }).map(Number.call, Number)
  return arr.map(num => {
    return {
      name: num + 1,
      value: num + 1
    }
  })
}
export function mToN (m, n) {
  const arr = Array.apply(null, { length: n - (m - 1) }).map(Number.call, Number)
  return arr.map(num => {
    return num + m
  })
}
